/**
 * @desc 根据 code 查询子项
 */
import { DictItemEntity } from '@eastcoal/api/system/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryDictItemsParameter = {
  code?: string
}

const method = 'GET'
const url = '/system/dict/items'

export const queryDictItemsApi = (
  params?: QueryDictItemsParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<DictItemEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryDictItemsApi.method = method
queryDictItemsApi.url = url
